export interface IAIChatRequest {
    Prompt: string;
    ConversationId?: string;
}

export interface IAIChatSource {
    ObjectType: number;
    ObjectId: number;
    // Clean relative path, built by CCM2 from (ObjectType, ObjectId).
    SourceUrl: string;
    // Document title, resolved by CCM2 — shown as the source label.
    Title: string;
    Snippet: string;
    Score: number;
    // Business Area name of the source (passed through from the backend); empty when none.
    BusinessAreaName?: string;
}

export interface IAIChatResponse {
    Message: string;
    ConversationId: string;
    Sources: IAIChatSource[];
    // Present only when the answer spans 2+ Business Areas; otherwise render Message + Sources.
    Preamble?: string;
    Sections?: IAIChatAnswerSection[];
    // True when no relevant documentation was found — show the "no documentation" banner.
    NoAnswer?: boolean;
    // Optional up to 2 short follow-up questions (answer's language). When present, the panel shows a
    // "Try a follow-up" block above the input; empty/absent most of the time.
    FollowUps?: string[];
}

export interface IAIChatAnswerSection {
    BusinessAreaName: string;
    Message: string;
    Sources: IAIChatSource[];
}

export interface IAIConversationSummary {
    ConversationId: string;
    Description: string;
    CreatedAt: string;
    UpdatedAt: string;
}

export interface IAIConversationTurn {
    Role: string;
    Content: string;
    Sources: IAIChatSource[];
    // Carried on live assistant turns so segmented answers render per-Business-Area. Persisted
    // history turns from the server have only Content + Sources (rendered as the flat single answer).
    Preamble?: string;
    Sections?: IAIChatAnswerSection[];
    NoAnswer?: boolean;
    // In-session UI state: set once the user rated this answer (shows the "thanks" confirmation).
    Feedback?: 'up' | 'down';
    // Carried on the latest live assistant turn only: up to 2 suggested follow-up questions shown in the
    // "Try a follow-up" block above the input. Cleared when the user picks one or sends a new message.
    FollowUps?: string[];
}

export interface IAIConversationDetails {
    ConversationId: string;
    Description: string;
    CreatedAt: string;
    UpdatedAt: string;
    Messages: IAIConversationTurn[];
}

export const AI_CHAT_ROLE_USER = 'user';
export const AI_CHAT_ROLE_ASSISTANT = 'assistant';

export interface IAIChatAvailabilityResponse {
    IsAvailable: boolean;
}

export interface IAIChatFeedbackRequest {
    Rating: number; // 1 = thumbs up, 2 = thumbs down (mirrors AIChatFeedbackRating)
    AnswerIndex: number; // 0-based position of the rated answer in the conversation (dedup/toggle)
    Question: string;
    Answer: string;
    SourceDocumentIds: number[];
    ConversationId?: string;
}
